/**
 * Ordered RPC URL list: primary (paid/env node) first, then overflow
 * fallbacks, with trailing-slash duplicates removed.
 */
export function buildRpcUrlList(
  primary: string | undefined,
  fallbacks: string[],
): string[] {
  const seen = new Set<string>();
  return [primary, ...fallbacks].filter((url): url is string => {
    if (!url) return false;
    const key = url.replace(/\/+$/, '');
    if (seen.has(key)) return false;
    seen.add(key);
    return true;
  });
}
